module.exports = __webpack_public_path__ + "media/images/contact/fr-b377e77885d6a93660dcaf59f68ab2af.svg";